import React from 'react';
import T from 'prop-types';

import { permissions, DATA_TYPE } from '../../configs/constants';
import Tooltip from '../../../Tooltip';
import RadioButtonGroup from '../../../RadioButtonGroup';

const granularities = [
  ['daily', 'Daily'],
  ['weekly', 'Weekly'],
  ['monthly', 'Monthly'],
  ...(permissions.allowAdvancedExportModal
    ? [
        [
          'quarterly_f',
          'Quarterly (Fiscal)',
          '3-month reporting period. Based on fiscal year end (FYEM), or calendar year if FYEM is unknown.',
        ],
        [
          'quarterly',
          'Quarterly (Calendar)',
          '3-month reporting period. Based on calendar year end.',
        ],
        [
          'yearly_f',
          'Yearly (Fiscal)',
          '12-month reporting period. Based on fiscal year end (FYEM), or calendar year if FYEM is unknown.',
        ],
        ['yearly', 'Yearly (Calendar)', '12-month reporting period. Based on calendar year end.'],
      ]
    : [['quarterly', 'Quarterly']]),
];
const options = (dataType) =>
  granularities.map(([value, text, tooltip]) => ({
    id: value,
    value,
    text,
    ...(tooltip
      ? {
          subElement: (
            <>
              {dataType === DATA_TYPE.BASE && value !== 'quarterly' && <sup>*</sup>}
              <Tooltip content={tooltip}>
                <i className="hicon-question-circle" />
              </Tooltip>
            </>
          ),
        }
      : {}),
  }));

const DateGranularity = ({ active, exclude, dataType, disabledOptions, onChange }) => {
  let filteredOptions = options(dataType).map((option) => ({
    ...option,
    disabled: disabledOptions?.includes(option.value),
  }));

  if (exclude?.length > 0) {
    filteredOptions = options(dataType).filter((option) => !exclude.includes(option.value));
  }

  return (
    <section className="export-settings-section date-granularity-section">
      <div className="export-settings-section__about">
        <h4 className="h5 export-settings-section__title">Raw Date Granularity</h4>
        <p className="paragraph-md export-settings-section__description">
          Determines the level of granularity your data is presented.
        </p>
      </div>
      <div className="export-settings-section__content">
        <RadioButtonGroup
          active={active}
          options={filteredOptions}
          name="date-granularity"
          className="export-settings-section__options date-granularity-options"
          enabled
          onChange={onChange}
        />
        {dataType === DATA_TYPE.BASE && <p className="service-info-text">*Only available as CSV</p>}
      </div>
    </section>
  );
};

DateGranularity.propTypes = {
  active: T.string.isRequired,
  exclude: T.arrayOf(T.oneOf(granularities.map(([value]) => value))),
  disabledOptions: T.arrayOf(T.oneOf(granularities.map(([value]) => value))),
  dataType: T.string,
  onChange: T.func.isRequired,
};

export default DateGranularity;
